import {IElement, ICommonAttributes} from 'routes/private/Editor/types';

export const hideUnhideResolver = ( element: IElement, value: string | undefined , hiddenChangeOrigin: string | undefined) => {
    if (value===undefined) {
        (element.attributes as ICommonAttributes).hidden = !(element.attributes as ICommonAttributes).hidden;    
    }
    else {
        (element.attributes as ICommonAttributes).hidden = (value === 'true')?true:(value === 'false')?false:(element.attributes as ICommonAttributes).hidden;
    }
    if (hiddenChangeOrigin) {
        (element.attributes as ICommonAttributes).hiddenChangeOrigin = hiddenChangeOrigin;    
    }
    return element;
}